import request from '@/router/axios'
import env from '@/config/env'

/**
 * 红冲
 * @param serialNo
 */
export const resetRed = (serialNo) => {
  return request({
    url: env.ferryUrl + '/invoice/invoice-record/red',
    method: 'get',
    params: {
      serialNo
    }
  })
}

export const reset = (orderTicketId, state) => {
  return request({
    url: env.ferryUrl + '/invoice/invoice-record/reset',
    method: 'get',
    params: {
      orderTicketId,
      state
    }
  })
}
export const invoiceRecordPage = (data) => {
  return request({
    url: env.ferryUrl + '/invoice/invoice-record/invoiceRecordPage',
    method: 'post',
    data
  })
}
// export const companySearch = (data) => {
//   return request({
//     url: env.ferryUrl + '/invoice/invoice-record/companySearch',
//     method: 'post',
//     data
//   })
// }
export const companySearch = (data) => {
  return request({
    url: env.ferryUrl + '/invoice/invoice-record/enterpriseTitleRetrieve',
    method: 'post',
    data
  })
}
// 企业抬头详情
export const companyTitleDetail = (data) => {
  return request({
    url: env.ferryUrl + '/invoice/invoice-record/enterpriseTitleDetail',
    method: 'post',
    data
  })
}

export const itineraryMsgInfo = (data) => {
  return request({
    url: env.ferryUrl + '/invoice/invoice-record/itineraryMsgInfo',
    method: 'post',
    data
  })
}
export const bossInvoice = (data) => {
  return request({
    url: env.ferryUrl + '/invoice/invoice-record/bossInvoice',
    method: 'post',
    data
  })
}

/**
 * 获取发票行程信息
 * @param serialNo
 */
export const invoiceItinerary = (serialNo) => {
  return request({
    url: env.ferryUrl + `/orderAdmin/itinerary/${serialNo}`,
    method: 'get'
  })
}

/**
 * 获取发票行程信息
 * @param serialNo
 */
export const sendInvoice = (params) => {
  return request({
    url: env.ferryUrl + '/orderAdmin/send-invoice',
    method: 'post',
    data: params
  })
}
/**
 * 同城接送订单发票重置
 * @param orderId
 * @param status
 */
export const ferryReset = (data) => {
  return request({
    url: env.ferryUrl + '/orderAdmin/updateInvoiceState',
    method: 'put',
    data
  })
}
/**
 * 城际结束行程
 * @param orderId
 */
export const resetEndOfTrip = (orderId) => {
  return request({
    url: env.ferryUrl + '/c-order/endOfTrip',
    method: 'get',
    params: {
      orderId
    }
  })
}
/**
 * 同城结束行程
 * @param orderId
 */
export const resetEndFerryTrip = (orderId) => {
  return request({
    url: env.ferryUrl + '/orderAdmin/endFerryTrip',
    method: 'get',
    params: {
      orderId
    }
  })
}

// 判断是否开具多张发票
export const singleInvoice = (params) => {
  return request({
    url: env.ferryUrl + '/work-order/judge-single-invoice',
    method: 'post',
    data: params
  })
}

// 获取行程信息
export const itineraryInfo = (params) => {
  return request({
    url: env.ferryUrl + '/invoice/invoice-record/itinerary',
    method: 'post',
    data: params
  })
}

/**
 * 发票重置校验
 */
export const resetVerification = (orderId) => {
  return request({
    url: env.ferryUrl + '/invoice/invoice-record/resetVerification',
    method: 'GET',
    params: {
      orderId
    }
  })
}

/**
 * 发票二次确认(邮件确认或红冲确认)
 */
export const confirmInvoiceAction = (data) => {
  return request({
    url: env.ferryUrl + '/invoice/invoice-record/confirm-email-issuance',
    method: 'POST',
    data
  })
}
